import React, { Suspense } from 'react';
import { connect } from 'react-redux';

import { isGeoBooked } from '../../application/redux/data/dataSelectors';
import type { RootState } from '../../configuration/setup/store';
import { fetchGeofences } from '../fetchData/fetchGeofences';
import { fetchPois } from '../fetchData/fetchPois';
import Options from '../options/Options';
import RoutesResultContainer from '../routes/RoutesResult';
import SearchEditorContainer from '../search/SearchEditor';
import { UpsellingContainer } from '../upselling/Upselling';
import { useEffectOnce } from './hooks';

export interface RoutePlannerProps {
    hasGeoBeenBooked?: boolean;
    fetchData: () => void;
}

export const RoutePlanner = React.memo((props: RoutePlannerProps) => {
    const { hasGeoBeenBooked, fetchData } = props;

    useEffectOnce(() => {
        fetchData();
    });

    return (
        <div className={'RoutePlanner height-100vh overflow-hidden display-flex flex-column'}>
            <Suspense fallback={''}>
                <div className={'overflow-auto padding-left-15 padding-top-15 padding-bottom-25 padding-right-15'}>
                    {hasGeoBeenBooked ? (
                        <React.Fragment>
                            <SearchEditorContainer />
                            <Options />
                        </React.Fragment>
                    ) : (
                        <div>
                            <UpsellingContainer />
                        </div>
                    )}
                </div>
                {hasGeoBeenBooked && <RoutesResultContainer />}
            </Suspense>
        </div>
    );
});

export const mapDispatchToProps = (dispatch: Function) => ({
    fetchData: () => {
        dispatch(fetchPois);
        dispatch(fetchGeofences);
    },
});

export const mapStateToProps = (state: RootState) => ({
    hasGeoBeenBooked: isGeoBooked(state),
});

export const RoutePlannerContainer = connect(mapStateToProps, mapDispatchToProps)(RoutePlanner);
